import { AttributeValue } from "src/common/attributes/valueTypes/AttributeValue";
import { EdCardValues } from "./apiEntityCard";

// Считается, что initialValues содержит все возможные данные
// А values могут быть не все, т.к. некоторые поля появляются только при определённых условиях

// Специальный случай № 1
// Есть такой кейс, когда в списке entity отсутствует запись id, которая есть в списке атрибутов.
// В этом случае initialValues[id] = undefined
// Но если ввести что-нибудь в поле (если это текст), а затем очистить, то values[id] = [""]
// Будем считать, что это означает, что изменений не произошло

const isEqual = (actual: AttributeValue, initial: AttributeValue): boolean => {
  const sActual = JSON.stringify(actual);
  if (initial === undefined && sActual === `[""]`) return true; // Спец случай № 1
  return sActual === JSON.stringify(initial);
};

export const isValuesChanged = (
  values: EdCardValues,
  initialValues: EdCardValues,
): boolean =>
  Object.entries(values).some(
    ([key, value]) => !isEqual(value, initialValues[key]),
  );

export const getChangedValues = (
  values: EdCardValues,
  initialValues: EdCardValues,
): EdCardValues =>
  Object.entries(values).reduce((acc, [key, value]) => {
    if (isEqual(value, initialValues[key])) return acc;
    acc[key] = values[key];
    return acc;
  }, {} as EdCardValues);
